import styled from 'styled-components';
import {Button, TextField} from '@mui/material';
import { media } from '../../theme/breakpoints';
import theme from '../../theme/theme';

export const LoginContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100vh;
    background-color: #f9f9f9;
    padding: 36px;
`;

export const LoginCard = styled.div`
    width: 100%;
    max-width: 450px;
    padding: 24px;
    background: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 40px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;

    ${media.sm} {
        padding: 32px;
        gap: 10px;
    }

    ${media.md} {
        padding: 40px;
        gap: 12px;
    }
`;

export const FormWrapper = styled.form`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;

    ${media.md} {
        gap: 22px;
    }
`;

export const StyledTextField = styled(TextField)`
    && {
        width: 100%;

        .MuiOutlinedInput-root {
            border-radius: 16px;
            background-color: #ffffff;

            & fieldset {
                border-color: #e0e0e0;
            }

            &:hover fieldset {
                border-color: ${theme.palette.primary.main};
            }

            &.Mui-focused fieldset {
                border-color: ${theme.palette.primary.main};
            }

            &.Mui-error fieldset {
                border-color: #d32f2f;
            }

            &.Mui-error:hover fieldset {
                border-color: #d32f2f;
            }

            &.Mui-error.Mui-focused fieldset {
                border-color: #d32f2f;
            }
        }

        .MuiInputLabel-root {
            font-family: 'Manrope', sans-serif;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            letter-spacing: -0.02em;
            color: #262626;

            &.Mui-focused {
                color: ${theme.palette.primary.main};
            }

            &.Mui-error {
                color: #d32f2f;
            }

            &.Mui-error.Mui-focused {
                color: #d32f2f;
            }
        }

        input {
            font-family: 'Manrope', sans-serif;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            color: #262626;
        }

        input:-webkit-autofill {
            box-shadow: 0 0 0 1000px #ffffff inset;
            -webkit-text-fill-color: #262626;
        }
    }
`;

export const ForgotPasswordWrapper = styled.div`
    width: 100%;
    text-align: right;
    margin-top: -10px;

    a {
        font-family: 'Manrope', sans-serif;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: -0.02em;
        color: ${theme.palette.primary.main};
        text-decoration: underline;

        &:hover {
            text-decoration: none;
        }
    }
`;

export const StyledButton = styled(Button)`
    && {
        width: 100%;
        height: 60px;
        background-color: ${theme.palette.primary.main};
        border-radius: 16px;
        font-family: 'Manrope', sans-serif;
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;
        letter-spacing: -0.02em;
        color: #fafafa;
        text-transform: none;

        &:hover {
            background-color: ${theme.palette.primary.main};
        }
    }
`;

export const RegisterLink = styled.div<{ disabled?: boolean }>`
    margin-top: 10px;
    text-align: center;
    width: 100%;
    font-family: 'Manrope', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.02em;
    color: ${theme.palette.primary.main};
    cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
    text-decoration: underline;

    &:hover {
        text-decoration: ${({ disabled }) => (disabled ? 'underline' : 'none')};
    }
`;

export const ErrorText = styled.div`
    font-family: 'Manrope', sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #d32f2f;
    margin-top: 4px;
`;
